import { render, staticRenderFns } from "./SchemeRows.vue?vue&type=template&id=05f0a94a"
import script from "./SchemeRows.vue?vue&type=script&lang=js"
export * from "./SchemeRows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports